<script>
import { globalVariablesMixin } from '../../../Mixins/global'
import buttonMixins from './buttonMixins'
import mixinComponent from '../../../Mixins/mixinComponent'
import Loader from '../Loading/Loader.vue'
import { truncate } from '../../../Utils/string'

export default {
  components: { Loader },
  mixins: [globalVariablesMixin, buttonMixins, mixinComponent],

  props: {
    href: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '_self',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    truncated: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: false,
    },
    tip: {
      type: String,
      required: false,
    },
    submit: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dynamicLabel() {
      return this.$te(this.label) ? this.$t(this.label) : this.label
    },
    truncatedLabel() {
      return this.truncated ? truncate(this.dynamicLabel, {}, false) : this.dynamicLabel
    },
    title() {
      return (this.$te(this.tip) ? this.$t(this.tip) : this.tip) ?? this.dynamicLabel
    },
    cursor() {
      return 'cursor: ' + (this.disabled || this.loading ? 'not-allowed' : 'pointer')
    },
    dynamicButtonClasses() {
      return {
        ...this.buttonClasses,
        'cursor-disabled': this.disabled,
        'cursor-pointer': !this.disabled,
      }
    },
    dynamicButtonAddIcon() {
      return this.buttonAddIcon + (this.disabled ? ' cursor-disabled' : ' cursor-pointer')
    },
  },

  methods: {
    onClick() {
      if (!!this.href) {
        window.open(this.href, this.target)
      }
    },
  },
}
</script>
<template>
  <button
    :type="submit ? 'submit' : 'button'"
    data-provide="tooltip"
    data-placement="right"
    :title="title"
    :class="dynamicButtonClasses"
    :disabled="disabled || loading"
    :e2e-button="name"
    @click="onClick"
  >
    <Loader v-if="loading" style="min-height: 1lh" />

    <template v-else-if="!loading && !label">
      <i :class="dynamicButtonAddIcon"></i>
    </template>

    <template v-else>
      <label v-if="iconLeft" :class="iconClasses"><i :class="dynamicButtonAddIcon"></i></label>
      {{ truncatedLabel }}
      <label v-if="iconRight" :class="iconClasses"><i :class="dynamicButtonAddIcon"></i></label>
    </template>
  </button>
</template>
<style scoped>
label {
  margin-bottom: 0;
}
</style>
